<template>
  <cargo-dialog
    v-el-drag-dialog
    custom-class="import-bill-address-title-dialog"
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_contactInformationCode')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    :can-maximize="true"
    @close="innerVisible = false"
  >
    <div class="filters">
      <el-form label-width="80px" label-position="left" style="margin-bottom: 5px">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
              <cargo-company-select
                no="partnerId"
                :method-params="{customer:true}"
                :default-value="filter.partnerId"
                @change="p=>{filter.partnerId=p.value}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
              <cargo-advance-select
                no="pod"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="filter.pod"
                @parentCallBack="p=>filter.pod=p.value"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_ShipperId')">
              <el-input v-model="filter.shipperCode" no="shipperCode" style="margin-right: 20px;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_ConsigneeId')">
              <el-input v-model="filter.consigneeCode" no="consigneeCode" style="margin-right: 20px;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_NotifyId')">
              <el-input v-model="filter.notifyCode" no="notifyCode" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_ShipperSName')">
              <el-input v-model="filter.shipperName" no="shipperName" style="margin-right: 20px;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_ConsigneeSName')">
              <el-input v-model="filter.consigneeName" no="consigneeName" style="margin-right: 20px;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_NotifyPartySName')">
              <el-input v-model="filter.notifyName" no="notifyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :gutter="10" style="text-align: left">
            <el-button type="primary" no="query" @click="toQuery">{{ $t('common.btn.query') }}</el-button>
            <el-button type="primary" no="reset" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;min-height:300px"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button type="primary" no="all" @click="choose(['shipperInfo','consigneeInfo','notifyInfo'])">{{ $t('CargoMsg.Cargo_All') }}</el-button>
      <el-button type="primary" no="shipperInfo" @click="choose(['shipperInfo'])">{{ $t('CargoMsg.Cargo_Shipper') }}</el-button>
      <el-button type="primary" no="consigneeInfo" @click="choose(['consigneeInfo'])">{{ $t('CargoMsg.Cargo_Consignee') }}</el-button>
      <el-button type="primary" no="notifyInfo" @click="choose(['notifyInfo'])">{{ $t('CargoMsg.Cargo_NotifyParty') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </cargo-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getMailingAddressList } from '@/api/partner/mailingAddress'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'

export default {
  name: 'ImportBillAddressTitleDialog',
  components: { CargoDialog, cargoAdvanceSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      filter: {
        lob: '',
        pod: '',
        shipperCode: '',
        consigneeCode: '',
        notifyCode: '',
        officeId: '',
        partnerId: '',
        shipperLine1: '',
        consigneeLine1: '',
        notifyLine1: '',
        shipperName: '',
        consigneeName: '',
        notifyName: ''
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 130,
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          const selectedNode = nodes[event.rowIndex]
          if (selectedNode) {
            this.selectedRow = selectedNode.data || null
          } else {
            this.selectedRow = null
          }
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ShipperId'),
          field: 'shipperCode',
          suppressMenu: true,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ShipperInfo'),
          field: 'shipperInfo',
          suppressMenu: true,
          width: 200,
          cellRenderer: this.multipleDataRellRenderer
        }, {
          headerName: this.$t('CargoMsg.Cargo_ConsigneeId'),
          field: 'consigneeCode',
          suppressMenu: true,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ConsigneeInfo'),
          field: 'consigneeInfo',
          suppressMenu: true,
          width: 200,
          cellRenderer: this.multipleDataRellRenderer
        }, {
          headerName: this.$t('CargoMsg.Cargo_NotifyId'),
          field: 'notifyCode',
          suppressMenu: true,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_NotifyInfo'),
          field: 'notifyInfo',
          suppressMenu: true,
          width: 200,
          cellRenderer: this.multipleDataRellRenderer
        }
      ],
      rowData: [],
      gridApi: null,
      selectedRow: null
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.filter.partnerId = this.job.customerId
        this.toQuery()
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.selectedRow = null
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.filter.partnerId = this.job.customerId
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      this.filter.lob = this.job.lob
      this.filter.officeId = this.$store.getters.currentOfficeId
      this.filter.shipperLine1 = this.filter.shipperName
      this.filter.consigneeLine1 = this.filter.consigneeName
      this.filter.notifyLine1 = this.filter.notifyName
      getMailingAddressList(this.filter).then(res => {
        this.rowData = res.data.list
      })
    },
    reset() {
      for (const key in this.filter) {
        this.filter[key] = ''
      }
    },
    multipleDataRellRenderer(params) {
      if (params.value !== undefined) {
        return params.value.replace(/<br\/>/g, '<br/>')
      }
      return ''
    },
    choose(fieldKeys) {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const data = {}
      for (const key of fieldKeys) {
        data[key] = this.selectedRow[key]
        if (data[key]) {
          data[key] = data[key].replace(new RegExp('<br\s*/>', 'g'), '\n')
        }

        data.shipperCode = this.selectedRow.shipperCode
        data.consigneeCode = this.selectedRow.consigneeCode
        data.notifyCode = this.selectedRow.notifyCode
      }
      this.$emit('callback', data)
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
#app #tab-commonHawb .bill-address-dialog .el-form-item__content {
  width: auto !important;
}
#app .app-main-inner .import-bill-address-title-dialog .el-dialog__body {
  padding: 10px;
}
.app-main-content .details-view .main-content {
  .import-bill-address-title-dialog {
    .title:before {
      width: 0px;
    }
    .title {
      padding-left: 0px;
      line-height: 24px;
      font-size: 18px !important;
      color: #333;
      margin-bottom: 0px;
    }
  }
}
</style>
